import Box from '@totallymoney/ui/components/Box'
import Heading from '@totallymoney/ui/components/Heading'
import Text from '@totallymoney/ui/components/Text'
import AlertCheckmark from '@totallymoney/ui/icons/AlertCheckmark'
// @ts-ignore
import AlertInfo from '@totallymoney/ui/icons/AlertInformation'
import theme from '@totallymoney/ui/theme'
import * as React from 'react'

interface ProsAndConsListProps {
    list: string[]
    listHeading: string
}

const ProsAndConsList = ({
    list,
    listHeading,
}: ProsAndConsListProps): React.ReactElement => {
    return (
        <Box>
            <Box mb="4px" display="flex" alignItems="center">
                <Box mr="space10" alignItems="center" display="flex">
                    {listHeading === 'Great for' && (
                        <AlertCheckmark
                            size={24}
                            color={theme.dataVisualisationTeal}
                        />
                    )}
                    {listHeading === 'Beware of' && (
                        <AlertInfo size={24} color={theme.alertError100} />
                    )}
                </Box>
                <Heading variant="60">{listHeading}</Heading>
            </Box>
            <Box
                height={1}
                backgroundColor={theme.productNeutral140}
                mb="space20"
            />
            <Box pl="5px" pr={2}>
                <Box
                    as="ul"
                    display="grid"
                    gridGap="space10"
                    pl="space20"
                    style={{ listStyleType: 'disc' }}
                >
                    {list?.map(item => (
                        <Box as="li" key={item} pl="space10">
                            <Text>{item}</Text>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}

export default ProsAndConsList
